import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "./modal/Modal";
import Item from "./Item";

const Portfolio = () => {
  const [getModal, setGetModal] = useState(false);
  const [modalData, setModalData] = useState(1);

  const handleModal = (item) => {
    setGetModal(true);
    setModalData(item);
  };

  return (
    <>
      <div className="portfolio-main min-h-screen">
        <Tabs>
          <TabList className="portfolio-tab-list" data-aos="fade-up">
            <Tab>ALL</Tab>
            <Tab>React</Tab>
            {/* <Tab>Nextjs</Tab> */}
            <Tab>Angular</Tab>
            <Tab>Nodejs</Tab>
          </TabList>

          <div className="container">
            <TabPanel>
              <Item tag="all" handleModal={handleModal} />
            </TabPanel>

            <TabPanel>
              <Item tag="react" handleModal={handleModal} />
            </TabPanel>

            <TabPanel>
              <Item tag="angular" handleModal={handleModal} />
            </TabPanel>

            <TabPanel>
              <Item tag="node" handleModal={handleModal} />
            </TabPanel>
          </div>
        </Tabs>
      </div>
      {getModal && <Modal modalData={modalData} setGetModal={setGetModal} />}{" "}
    </>
  );
};

export default Portfolio;
